import dayjs from "dayjs";

export const DAILY_REPORT_DAY_FORMAT = "YYYY-MM-DD";
export const DAILY_REPORT_DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss";

/**
 * Resolve o limite superior da consulta no momento da requisição: "agora" para o dia atual
 * e o fim do dia para datas anteriores. Permite que a atualização automática reaproveite a
 * mesma query key (sem skeleton) e que a virada de dia não congele o horário anterior.
 */
export function resolveDailyReportDateTime(day: string | null): string | null {
    if (!day) return null;
    const parsed = dayjs(day);
    if (!parsed.isValid()) return day;
    if (parsed.isBefore(dayjs(), "day")) return parsed.endOf("day").format(DAILY_REPORT_DATE_TIME_FORMAT);
    return dayjs().format(DAILY_REPORT_DATE_TIME_FORMAT);
}

/** Parte da data usada nas query keys, estável durante todo o dia selecionado. */
export function toDailyReportDayKey(day: string | null): string | null {
    return day ? day.substring(0, 10) : null;
}
